<template>
    <v-container class="py-7">
        <v-row>
            <v-col cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined to="/avaliacoes">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Contexto pedagógico</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select dense label="Turma" :items="dataset.classes" item-text="name" item-value="id"
                                        v-model="dataset.data.class_id" :rules="[$rules.required]" required outlined hide-details="auto" />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select dense label="Componente da turma" :items="dataset.offerings"
                                        :item-text="offeringLabel" item-value="id"
                                        v-model="dataset.data.class_component_id" :rules="[$rules.required]"
                                        :disabled="!dataset.data.class_id" required outlined hide-details="auto" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select dense label="Período acadêmico" :items="dataset.periods" item-text="name" item-value="id"
                                        v-model="dataset.data.period_id" :rules="[$rules.required]" required outlined hide-details="auto" />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select dense label="Professor" :items="offeringTeachers" item-text="name" item-value="id"
                                        v-model="dataset.data.teacher_id" :rules="[$rules.required]"
                                        :disabled="!dataset.data.class_component_id" required outlined hide-details="auto" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Avaliação</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense label="Título" v-model="dataset.data.title"
                                        :rules="[$rules.required]" required outlined hide-details="auto" />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense label="Tipo" :items="dataset.assessmentTypes" item-text="name" item-value="id"
                                        v-model="dataset.data.type" :rules="[$rules.required]" required outlined hide-details="auto" />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field dense label="Data" type="date" v-model="dataset.data.end_date"
                                        :rules="[$rules.required]" required outlined hide-details="auto" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense label="Descrição" v-model="dataset.data.description"
                                        :rules="[$rules.required]" required outlined rows="3" hide-details="auto" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="!page.isNew">
                <v-col cols="12">
                    <v-card class="table-card">
                        <v-card-title class="table-card-title">Lançamento de notas</v-card-title>
                        <v-card-text>
                            <v-data-table :headers="grades.headers" :items="grades.data" :loading="grades.loading"
                                disable-sort hide-default-footer no-data-text="Nenhum aluno matriculado nesta turma"
                                loading-text="Carregando alunos..." class="app-table hover-table">

                                <template v-slot:[`item.grade`]="{ item }">
                                    <v-text-field dense type="number" min="0" max="10" step="0.1"
                                        v-model="item.grade" outlined hide-details />
                                </template>

                                <template v-slot:[`item.date`]="{ item }">
                                    <v-text-field dense type="date" v-model="item.date" outlined hide-details />
                                </template>

                                <template v-slot:[`item.description`]="{ item }">
                                    <v-text-field dense v-model="item.description" outlined hide-details />
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-btn small color="primary" elevation="0" :loading="item.loading"
                                        @click="saveGrade(item)">Salvar</v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: "AssessmentDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
                type: 1,
            },
            classes: [],
            courses: [],
            offerings: [],
            periods: [],
            teachers: [],
            assessmentTypes: [
                { id: 1, name: "Prova" },
                { id: 2, name: "Trabalho" },
                { id: 3, name: "Atividade" },
                { id: 4, name: "Recuperação" },
            ],
        },
        loadingAssessment: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
        },
        grades: {
            loading: false,
            headers: [
                { text: "Aluno", value: "student_name" },
                { text: "Nota", value: "grade" },
                { text: "Data", value: "date" },
                { text: "Observação", value: "description" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            data: [],
        },
    }),

    created() {
        this.loadData();
    },

    computed: {
        selectedOffering() {
            return this.dataset.offerings.find(
                (offering) => Number(offering.id) === Number(this.dataset.data.class_component_id)
            );
        },

        offeringTeachers() {
            if (!this.selectedOffering) return [];
            return (this.selectedOffering.teachers || [])
                .map((assignment) => assignment.employee)
                .filter(Boolean);
        },
    },

    watch: {
        "dataset.data.class_id"(classId, previousClassId) {
            if (this.loadingAssessment || Number(classId) === Number(previousClassId)) return;
            this.dataset.data.class_component_id = null;
            this.dataset.data.course_id = null;
            this.dataset.data.teacher_id = null;
            this.loadOfferings(classId);
        },

        "dataset.data.class_component_id"(offeringId) {
            if (this.loadingAssessment) return;
            const offering = this.dataset.offerings.find(
                (item) => Number(item.id) === Number(offeringId)
            );
            this.dataset.data.course_id = offering ? offering.course_id : null;
            const teachers = offering
                ? (offering.teachers || []).map((assignment) => assignment.employee).filter(Boolean)
                : [];
            if (teachers.length === 1) this.dataset.data.teacher_id = teachers[0].id;
            else if (!teachers.some((teacher) => Number(teacher.id) === Number(this.dataset.data.teacher_id))) {
                this.dataset.data.teacher_id = null;
            }
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/avaliacoes");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.loadLookups();
            await this.load();
            await this.loadGrades();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Nova avaliação" : "Detalhes da avaliação";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: "Homepage", disabled: false, to: "/home", exact: true },
                { text: "Avaliações", disabled: false, to: "/avaliacoes", exact: true },
                { text: this.page.title, disabled: true, exact: true },
            ];
        },

        async loadLookups() {
            const params = { page: 1, limit: 100000, search: {} };
            const [classes, periods] = await Promise.all([
                axios.get("/api/v1/classes", { params }),
                axios.get("/api/v1/academic-periods", { params }),
            ]);

            this.dataset.classes = classes.data.content.data;
            this.dataset.periods = periods.data.content.data;
        },

        async loadOfferings(classId) {
            this.dataset.offerings = [];
            if (!classId) return;

            try {
                const result = await axios.get(`/api/v1/classes/${classId}/components`);
                this.dataset.offerings = (result.data.content && result.data.content.data) || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2000,
                });
            }
        },

        offeringLabel(offering) {
            if (!offering) return "Componente";
            const name = offering.course ? offering.course.name : "Componente";
            const teachers = (offering.teachers || [])
                .map((assignment) => assignment.employee && assignment.employee.name)
                .filter(Boolean);
            return teachers.length ? `${name} · ${teachers.join(", ")}` : `${name} · sem professor`;
        },

        async load() {
            if (this.page.isNew) return;

            try {
                this.loadingAssessment = true;
                const result = await axios.get(`/api/v1/assessments/${this.$route.params.id}`);
                const data = result.data.content;

                await this.loadOfferings(data.class_id);
                this.dataset.data = {
                    ...data,
                    class_component_id: data.class_component_id || (data.component && data.component.id),
                    end_date: data.end_date ? this.$moment(data.end_date).format("YYYY-MM-DD") : null,
                };
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                await this.$nextTick();
                this.loadingAssessment = false;
            }
        },

        async loadGrades() {
            if (this.page.isNew) return;

            this.grades.loading = true;

            try {
                const search = { assessment_id: this.$route.params.id };
                const result = await axios.get("/api/v1/grades", { params: { page: 1, limit: 100000, search: JSON.stringify(search) } });

                this.grades.data = result.data.content.data.map((item) => ({
                    ...item,
                    date: item.date ? this.$moment(item.date).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD"),
                    loading: false,
                }));
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.grades.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: "Deseja incluir a avaliação?",
                title: "Incluir avaliação",
                actions: { false: "Cancelar", true: "Salvar" },
            });

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                await axios.post("/api/v1/assessments", this.buildPayload());
                this.$dialog.notify.info("Avaliação salva com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: "Deseja atualizar a avaliação?",
                title: "Atualizar avaliação",
                actions: { false: "Cancelar", true: "Atualizar" },
            });

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            try {
                await axios.patch(`/api/v1/assessments/${this.$route.params.id}`, this.buildPayload());
                this.$dialog.notify.info("Avaliação atualizada com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        buildPayload() {
            return {
                title: this.dataset.data.title,
                description: this.dataset.data.description,
                type: this.dataset.data.type,
                class_component_id: this.dataset.data.class_component_id,
                class_id: this.dataset.data.class_id,
                course_id: this.dataset.data.course_id,
                period_id: this.dataset.data.period_id,
                teacher_id: this.dataset.data.teacher_id,
                end_date: this.dataset.data.end_date,
            };
        },

        async saveGrade(item) {
            if (!item || !item.student_id) return;

            item.loading = true;

            try {
                await axios.post("/api/v1/grades", {
                    assessment_id: this.$route.params.id,
                    student_id: item.student_id,
                    grade: item.grade,
                    date: item.date,
                    description: item.description,
                });

                this.$dialog.notify.info("Nota salva com sucesso!", { position: "top-right", timeout: 2000 });
                await this.loadGrades();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                item.loading = false;
            }
        },
    },
};
</script>
